import { WithStyles, withStyles } from '@mui/styles';

import { DocumentCenter } from './documentCenter';
import { muiStyles } from './documentCenterStyles';

export interface DocumentCenterProps extends WithStyles<typeof muiStyles> {}

export type DocumentDownloadStatus = 'noselection' |
    'fetching' |
    'fetched' |
    'failed';

export default withStyles(muiStyles)(DocumentCenter);